<template>
  <div class="formulate-input-element" :class="{ 'formulate-input--warning': warningToShow }">
    <CurrencyInput
      :value="value"
      v-bind="context.attributes"
      @focus="focusHandler"
      @blur="blurHandler"
      :options="options"
      @keyup.native="handleKeyUp"
    />
    <div v-if="context.attributes.slots" class="slots-wrapper slots-wrapper--sm">
      <InputSlot
        v-for="(slot, i) in context.attributes.slots"
        v-bind="slot.props"
        :key="`input-slot-${i}`"
        :component="slot.component"
        :children="slot.children"
      />
    </div>
    <div v-if="warningToShow" class="formulate-input-warning">
      <i class="icon icon-warning icon-xxxs"></i>
      <p>
        {{ warningToShow.warning }}
        <a v-if="action && warningToShow.value" @click="update(warningToShow.value)">{{ action }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import InputSlot from '@/funnels/components/form/InputSlot';
import '@/prototypes/index.js';
import CurrencyInput from './CurrencyInput';

export default {
  components: { CurrencyInput, InputSlot },
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  computed: {
    locale() {
      return this.context.locale || 'es-ES';
    },
    currency() {
      return this.context.currency || 'EUR';
    },
    currencyDisplay() {
      return this.context.currencyDisplay || 'symbol';
    },
    valueRange() {
      return this.context.attributes.valueRange || { min: 0 };
    },
    precision() {
      return this.context.precision || 0;
    },
    hideCurrencySymbolOnFocus() {
      return this.context.hideCurrencySymbolOnFocus || true;
    },
    hideGroupingSeparatorOnFocus() {
      return this.context.hideGroupingSeparatorOnFocus || false;
    },
    hideNegligibleDecimalDigitsOnFocus() {
      return this.context.hideNegligibleDecimalDigitsOnFocus || true;
    },
    autoDecimalDigits() {
      return this.context.autoDecimalDigits || false;
    },
    valueScaling() {
      return this.context.valueScaling || undefined;
    },
    autoSign() {
      return this.context.autoSign || true;
    },
    useGrouping() {
      return this.context.useGrouping || true;
    },
    required() {
      return !this.context.attributes.noRequired;
    },
    showPlaceholder() {
      return !!this.context.attributes.showPlaceholder;
    },
    readonly() {
      return !!this.context.attributes.readonly;
    },
    warnings() {
      return this.context.attributes.warnings;
    },
    warningToShow() {
      return this.warnings?.filter(warning => warning.condition)[0];
    },
    action() {
      return this.context.attributes.action;
    },
    options() {
      return {
        locale: this.locale,
        currency: this.currency,
        currencyDisplay: this.currencyDisplay,
        valueRange: this.valueRange,
        precision: this.precision,
        hideCurrencySymbolOnFocus: this.hideCurrencySymbolOnFocus,
        hideGroupingSeparatorOnFocus: this.hideGroupingSeparatorOnFocus,
        hideNegligibleDecimalDigitsOnFocus: this.hideNegligibleDecimalDigitsOnFocus,
        autoDecimalDigits: this.autoDecimalDigits,
        valueScaling: this.valueScaling,
        autoSign: this.autoSign,
        useGrouping: this.useGrouping,
        readonly: this.readonly,
      };
    },
    value() {
      if (!this.context.model && (!this.required || this.showPlaceholder)) {
        return null;
      }
      return (isNaN(this.context.model) ? this.context.model.toString().currencyToInteger() ?? 0 : this.context.model) * 1;
    },
  },
  methods: {
    handleChange(e) {
      if (!e) {
        if (!this.required) this.context.model = null;
        else this.context.model = 0;
      } else {
        if (e.currencyToInteger() > this.valueRange.max) this.context.model = this.valueRange.max;
        else this.context.model = e.currencyToInteger();
      }
      this.$emit('change', e);
    },
    handleKeyUp(e) {
      this.handleChange(e.target.value);
    },
    focusHandler(e) {
      this.$emit('focus', e);
    },
    blurHandler(e) {
      this.context.blurHandler(e);
      this.$emit('blur', e);
    },
    update(val) {
      this.context.model = val;
    },
  },
};
</script>
